<template>
    <div class="info">
        <div class="title">
            <h1>预览报名信息<span> / Preview registration information </span></h1>
        </div>
        <div class="formInfo">
			<div class="info">
			    <!-- 基本信息所有考试都有 -->
			    <h2>基本信息</h2>
			    <el-form :model="enrollInfo" :rules="enrollRules" ref="enrollInfo" label-width="100px" label-position="left" @submit.native.prevent>
			        <el-form-item label="头像">
			            <img :src="user.headImg" style="display:inline-block;width:30%;"/>
			        </el-form-item>
					<el-form-item label="姓名">
			            {{user.name}}
			        </el-form-item>
					<el-form-item label="英文姓名">
					    {{user.englishName}}
					</el-form-item>
			        <el-form-item label="性别">
			            {{user.sex==1?"男":"女"}}
			        </el-form-item>
			        <el-form-item label="国籍">
			            {{user.nationId==0?'中国大陆':'其他'}}
			        </el-form-item>
			        <el-form-item label="地址">
			            {{user.province}} {{user.city}} {{user.region}} {{user.address}}
			        </el-form-item>
			        <el-form-item label="证件类型">
			            <!-- mapCertificateType(certificateTypeList) -->
			            {{user.certificateType}}
			        </el-form-item>
			        <el-form-item label="证件号码">
			            {{user.certificateNumber}}
			        </el-form-item>
			        <el-form-item label="证件" v-if="user.certificatePhotoA||user.certificatePhotoB">
			            <img :src="user.certificatePhotoA" style="display:inline-block;width:30%;" v-if="user.certificatePhotoA"/>
			            <img class="bbbbbbb" :src="user.certificatePhotoB" style="display:inline-block;width:30%;" v-if="user.certificatePhotoB"/>
			        </el-form-item>
			        <el-form-item label="联系电话" v-if="user.phone">
			            {{user.phone}}
			        </el-form-item>
			        <el-form-item label="邮箱" v-if="user.email">
			            {{user.email}}
			        </el-form-item>
			        <el-form-item label="QQ" v-if="user.qq">
			            {{user.qq}}
			        </el-form-item>
			        <el-form-item label="收件人" v-if="enrollReceiverVo.receiverName">
			            {{enrollReceiverVo.receiverName}}
			        </el-form-item>
			        <el-form-item label="电话" v-if="enrollReceiverVo.receiverPhone">
			            {{enrollReceiverVo.receiverPhone}}
			        </el-form-item>
			        <el-form-item label="收件地址" v-if="enrollReceiverVo.address">
			            {{enrollReceiverVo.address}}
			        </el-form-item>
			        <template v-for="grad in grad"><!-- ERMT CERM CAERM CSERM -->
			            <h2 v-if="1">最高学历</h2><!-- CERM CAERM CSERM -->
			            <!-- <h2 v-if="1">教育背景</h2>ERMT  -->
			            <el-form-item label="大学名称" v-if="grad.collegeName">
			                {{grad.collegeName}}
			            </el-form-item>
			            <el-form-item label="专业名称" v-if="grad.majorName">
			                {{grad.majorName}}
			            </el-form-item>
			            <el-form-item label="毕业年月" v-if="grad.gradTime">
			                {{grad.gradTime|dateTime('yyyy-MM')}}
			            </el-form-item>
			            <el-form-item label="学历证书" v-if="grad.eduCertUrl">
			                <img :src="grad.eduCertUrl" style="display:inline-block;width:30%;"/>
			            </el-form-item>
			            <el-form-item label="最高学历" v-if="grad.degreeLevel">
			                {{grad.degreeLevel}}
			            </el-form-item>
			            <!-- cserm 论文上传 -->
			            <!-- <el-form-item label="论文上传" v-if="grad.thesisUrl">
			                <a :href="grad.thesisUrl" download style="text-decoration:underline" v-if="grad.thesisUrl">{{grad.thesisName}}</a>
			            </el-form-item> -->
			        </template>
			        <template v-for="stud in stud"><!-- ERMT CERM CAERM CSERM -->
			            <h2>在读学历</h2>
			            <el-form-item label="大学名称" v-if="stud.universityName">
			                {{stud.universityName}}
			            </el-form-item>
			            <el-form-item label="专业名称" v-if="stud.majorName">
			                {{stud.majorName}}
			            </el-form-item>
			            <el-form-item label="入学年月" v-if="stud.enrollmentTime">
			                {{stud.enrollmentTime|dateTime('yyyy-MM')}}
			            </el-form-item>
			            <el-form-item label="学生证" v-if="stud.studentCardUrl">
			                <img :src="stud.studentCardUrl" style="display:inline-block;width:30%;"/>
			            </el-form-item>
			            <el-form-item label="在读学历" v-if="stud.studLevel">
			                {{stud.studLevel}}
			            </el-form-item>
			            <!-- cserm 论文上传 -->
			            <el-form-item label="论文上传" v-if="stud.thesisUrl">
							<a :href="stud.thesisUrl" download style="text-decoration:underline" v-if="stud.thesisUrl">{{stud.thesisUrl}}</a>
			            </el-form-item>
			        </template>
			
			        <template v-for="c in comp">
			            <h2 v-if="c.status==0">现工作单位</h2>
			            <h2 v-if="c.status==1">前工作单位</h2>
			            <el-form-item label="时间阶段" v-if="c.startDate">
			                {{c.startDate|dateTime('yyyy-MM-dd')}}~{{c.endDate|dateTime('yyyy-MM-dd')}}
			            </el-form-item>
			            <el-form-item label="工作单位名称" v-if="c.companyName">
			                {{c.companyName}}
			            </el-form-item>
			            <el-form-item label="工作单位所在行业" v-if="c.status==0">
			                {{c.companyIndustry}}
			            </el-form-item>
			            <el-form-item label="工作单位规模" v-if="c.status==0">
			                {{c.companyScale}}
			            </el-form-item>
			            <el-form-item label="工作单位类型" v-if="c.status==0">
			                {{c.companyType}}
			            </el-form-item>
			            <el-form-item label="任职部门" v-if="c.status==0">
			                {{c.department}}
			            </el-form-item>
			            <el-form-item label="职位" v-if="c.status==0">
			                {{c.position}}
			            </el-form-item>
			            <el-form-item label="主要职责" v-if="c.status==0">
			                {{c.duty}}
			            </el-form-item>
			            <el-form-item label="证明人" v-if="c.firstReterence">
			                {{c.firstReterence}}
			            </el-form-item>
			            <el-form-item label="证明人职位" v-if="c.firstPosition">
			                {{c.firstPosition}} 
			            </el-form-item>
			            <el-form-item label="证明人电话" v-if="c.firstPhone">
			                {{c.firstPhone}}
			            </el-form-item>
			            <el-form-item label="第二位证明人" v-if="c.secondReterence">
			                {{c.secondReterence}}
			            </el-form-item>
			            <el-form-item label="第二位证明人职位" v-if="c.secondPosition">
			                {{c.secondPosition}} 
			            </el-form-item>
			            <el-form-item label="第二位证明人电话" v-if="c.secondPhone">
			                {{c.secondPhone}}
			            </el-form-item>
			            <el-form-item label="第三位证明人" v-if="c.thirdReterence">
			                {{c.thirdReterence}}
			            </el-form-item>
			            <el-form-item label="第三位证明人职位" v-if="c.thirdPosition">
			                {{c.thirdPosition}}
			            </el-form-item>
			            <el-form-item label="第三位证明人电话" v-if="c.thirdPhone">
			                {{c.thirdPhone}}<br/>
			            </el-form-item>
			            <el-form-item label="相关工作业绩和成就描述" v-if="c.status==1&&c.remark">
			                {{c.remark}}
			            </el-form-item>
			            <el-form-item label="申请人风险管理相关工作业绩和成就描述" v-if="c.status==1&&c.secondRemark">
			                {{c.secondRemark}}
			            </el-form-item>
			
			        </template>
			        <!-- <h2>前工作单位</h2>
			        <el-form-item label="时间阶段">
			            {{c.startDate}}~{{c.endDate}}
			        </el-form-item>
			        <el-form-item label="前工作单位名称">
			            {{c.companyName}}
			        </el-form-item>
			        <el-form-item label="证明人">
			            {{c.firstReterence}}{{c.firstPosition}}{{c.firstPhone}}<br/>
			            {{c.secondReterence}}{{c.secondPosition}}{{c.secondPhone}}<br/>
			            {{c.thirdReterence}}{{c.thirdPosition}}{{c.thirdPhone}}
			        </el-form-item>
			        <el-form-item label="申请人风险管理相关工作业绩和成就描述">
			            {{c.remark}}
			        </el-form-item> -->
			        <template v-if="cert.length" v-for="c in cert">
			            <template v-if="c.type==1">
							<!-- <h2>现有职业资格/职称（最高）</h2>
			                <el-form-item label="证书名称" v-if="c.certName">
			                    {{c.certName}}
			                </el-form-item>
			                <el-form-item label="证书" v-if="c.certUrl">
			                    <img :src="c.certUrl" style="display:inline-block;width:30%;"/>
			                </el-form-item>
			                <el-form-item label="证书类别" v-if="c.certType">
			                    {{c.certType}}
			                </el-form-item> -->
							<h2>现有职业资格/职称（最高）</h2>
							<el-form-item label="证书名称">
							    {{c.certName}}
							</el-form-item>
							<el-form-item label="证书">
							    <img :src="c.certUrl" style="display:inline-block;width:30%;"/>
							</el-form-item>
							<el-form-item label="证书类别">
							    {{c.certType}}
							</el-form-item>
			            </template>
			            <template v-if="c.type==2">
						<h2>特殊情况说明</h2>	
							<!-- <el-form-item label="特殊情况说明" v-if="c.specialDesc">
								{{c.specialDesc}}
							</el-form-item>
							<el-form-item label="证明材料" v-if="c.certUrl">
								<img :src="c.certUrl" style="display:inline-block;width:30%;"/>
							</el-form-item> -->
			                <el-form-item label="特殊情况说明">
			                    {{c.specialDesc}}
			                </el-form-item>
			                <el-form-item label="证明材料">
			                    <img :src="c.certUrl" style="display:inline-block;width:30%;"/>
			                </el-form-item>
			            </template>
			        </template>
			        <template v-for="c in commend">
			            <!-- cserm 专家和单位推荐信 -->
						<!-- <el-form-item label="专家推荐信" v-if="c.type==1">
						    <a :href="c.fileUrl" download style="text-decoration:underline" v-if="c.fileUrl">{{c.fileName}}</a>
						    <a style="text-decoration:none" v-else>{{c.fileName}}</a>
						</el-form-item>
						<el-form-item label="单位推荐信" v-if="c.type==2">
						    <a :href="c.fileUrl" download style="text-decoration:underline" v-if="c.fileUrl">{{c.fileName}}</a>
						    <a style="text-decoration:none" v-else>{{c.fileName}}</a>
						</el-form-item> -->
			            <el-form-item label="专家推荐信" v-if="c.type==1">
			                <a :href="c.fileUrl" download style="text-decoration:underline">{{c.fileName}}</a>
			            </el-form-item>
			            <el-form-item label="单位推荐信" v-if="c.type==2">
			                <a :href="c.fileUrl" download style="text-decoration:underline">{{c.fileName}}</a>
			                <!-- <upload-images v-model="c.fileUrl" :limit="1" :size="100" listType="text">
			                    <el-button size="small" type="primary">点击上传</el-button>
			                </upload-images> -->
			            </el-form-item>
			        </template>
			    </el-form>
			</div>
        </div>
        <div class="buttons">
            <el-button @click="prev">返回修改</el-button>
            <el-button :loading="submitLoading" @click="next">确认提交</el-button>
        </div>

        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
	import { EnrollInfoDetailAll } from '@/api/enroll'
	import { listByType } from '@/api/cms'
	export default {
		name: 'info',
		components: {
			
		},
		data(){
			return {
				level: '',
				submitLoading: false,
				dialogVisible: false,
				testurlid:'',
				dialogImageUrl: '',
				stud:[],//在读学历
				grad:[],//最高学历
				comp:[],//工作单位
				commend:[],//推荐信,
				cert:[],
				user:[],
				enrollReceiverVo:[],
				enrollInfo: {
					headImg: '',
					name: '',
					sex:' ',
					dddd: '',
					phone: '',
					qq: '',
					email: '',
					examType: '',
					certificateNumber: '',
					certificatePhotoA: '',
					certificatePhotoB: '',
					province:'',
					city:'',
					receiverName: '',
					address: '',
					receiveaddress:''
				},
				enrollRules:{},
				typeList: [
				    { label: '身份证', value: 1 },
				    { label: '护照', value: 2 },
					{ label: '台湾居民来大陆通行证', value: 3 },
					{ label: '香港身份证', value: 4 },
					{ label: '其他', value: -1 },
				],
				ffffList: [
				    { label: '大专', value: 1 },
				    { label: '本科', value: 2 },
				    { label: '硕士研究生', value: 3 },
				    { label: '博士研究生', value: 4 },
				],
				companyIndustryList: [
				    { label: '银行', value: '1' },
				    { label: '证券', value: '2' },
				    { label: '保险', value: '3' },
					{ label: '多元/互联网金融', value: '4' },
					{ label: '商贸', value: '5' },
					{ label: '会计审计', value: '6' },
					{ label: '核工业', value: '7' },
					{ label: '兵器兵装', value: '8' },
					{ label: '航天', value: '9' },
					{ label: '航空工业', value: '10' },
					{ label: '律师/法律', value: '11' },
					{ label: '机械制造', value: '12' },
					{ label: '建筑/建材', value: '13' },
					{ label: '房地产', value: '14' },
					{ label: '有色冶金', value: '15' },
					{ label: '纺织工业', value: '16' },
					{ label: '电子工业', value: '17' },
					{ label: '信息/通信', value: '18' },
					{ label: '批发/零食/租赁', value: '19' },
					{ label: '农/林/牧/渔,', value: '20' },
					{ label: '水利/电力', value: '21' },
					{ label: '交通/物流/仓储', value: '22' },
					{ label: '文化传媒', value: '23' },
					{ label: '教育科研', value: '24' },
					{ label: '咨询顾问', value: '25' },
					{ label: '食品', value: '26' },
					{ label: '旅游/餐饮/服务业', value: '27' },
					{ label: '医疗医药', value: '28' },
					{ label: '公共组织', value: '29' },
					{ label: '能源/石化/矿产', value: '30' },
					{ label: '其他', value: '-1' }
				],
				companyScaleList: [
				    { label: '100人以下', value: '1' },
				    { label: '100-999人', value: '2' },
				    { label: '1000-9999人', value: '3' },
				    { label: '10000人以上', value: '4' },
				],
				typeListsss: [
				    { label: '风控类', value: 1 },
				    { label: '经济类', value: 2 },
				    { label: '金融从业类', value: 3 },
					{ label: '财税/资产评估类', value: 4 },
					{ label: '审计类', value: 5 },
					{ label: '合规/法务类', value: 6 },
					{ label: '人力资源类', value: 7 },
					{ label: '信息技术类', value:8 },
					{ label: '质量/安全/环境类', value: 9 },
					{ label: '工程类', value: 10 },
					{ label: '项目/产品管理类', value: 11 },
					{ label: '医药类', value: 12 },
					{ label: '教师类', value: 13 },
					{ label: '其他', value: 14 },
				],
				positionList:[],
				companyTypeList:[]
			}
		},
		mounted(){
			listByType("work_title").then(res => {
				this.positionList = res
			})
			listByType("enterprise_type").then(res => {
				this.companyTypeList = res
			})
			this.$emit('changeIndex',3)
			this.level = this.$route.params.level
			this.testurlid=this.$route.params.id
			EnrollInfoDetailAll({id:this.testurlid}).then(r=>{
				this.user=r.enrollInfo
				this.enrollReceiverVo=r.enrollReceivers[0]
				this.stud=r.enrollStuds
				this.grad=r.enrollGrads
				this.comp=r.enrollCompanys
				this.cert=r.enrollCerts
				this.commend=r.enrollCommends
				this.thesis=r.enrollThesiss
				this.typeList.forEach(v=>{
					if(v.value==this.user.certificateType){
						this.user.certificateType=v.label
					}
				})
				this.grad.forEach(val=>{
					this.ffffList.forEach(v=>{
						if(v.value==val.degreeLevel){
							val.degreeLevel=v.label
						}
					})
				})
				this.stud.forEach(val=>{
					this.ffffList.forEach(v=>{
						if(v.value==val.studLevel){
							val.studLevel=v.label
						}
					})
				})
				this.comp.forEach(val=>{
					this.companyIndustryList.forEach(v=>{
						if(v.value==val.companyIndustry){
							val.companyIndustry=v.label
						}
					})
					this.companyScaleList.forEach(v=>{
						if(v.value==val.companyScale){
							val.companyScale=v.label
						}
					})
					this.companyTypeList.forEach(v=>{
						if(v.value==val.companyType){
							val.companyType=v.name
						}
					})
					this.positionList.forEach(v=>{
						if(v.value==val.position){
							val.position=v.name
						}
					})
				})
				this.cert.forEach(val=>{
					this.typeListsss.forEach(v=>{
						if(v.value==val.certType){
							val.certType=v.label
						}
					})
				})
			})
		},
		methods:{
			prev(){
				this.$router.replace(`/enroll/info/${this.level}/${this.testurlid}`)
			},
			next(){
				this.submitLoading = true
				setTimeout(() => {
					this.submitLoading = false
					this.$router.push(`/enroll/place/${this.level}/${this.testurlid}`)
				},300)
			},
			handlePictureCardPreview(url){
				this.dialogImageUrl = url
				this.dialogVisible = true
			},
		}
	}
</script>

<style scoped>
    @import './info.css';

    .formInfo{padding-top: 10px;}
    .formInfo>img{display: block;width: 126px;height: 175px;background: #d0d0d0;float: left;margin-right: 40px;}
    .formInfo ul{margin-top: -9px;}
    .formInfo ul li{line-height: 32px;}
    .formInfo ul li.image{line-height: 0;padding: 6px 0;}
    .formInfo ul li.image p{float: left;line-height: 18px;}
    .formInfo ul li.image span{display: block;float: left;}
    .formInfo ul li.image img{width: 182px;height: 119px;display: inline-block;border:1px solid #d0d0d0;margin-right: 20px;cursor: pointer;}
    .bbbbbbb{margin-left: 30px;}
</style>
